import userApi from '../../gateways/api/userApi';

const getMyInfo = userApi.getUserProfile;
const updateMyInfo = userApi.updateUserProfile;

export default {
  getMyInfo,
  updateMyInfo
};
